import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Anchor } from '@zillow/constellation';

/**
 * This component ensures that external links open in a new tab, unless we are in a webview. iOS
 * won't open the link at all in a webview if the target is blank
 */
export default function ExternalLink({ href, ...props }) {
  const isInWebView = useSelector((state) => state.app.isInWebView);
  const target = isInWebView ? '_self' : '_blank';

  return <Anchor href={href} target={target} {...props} />;
}

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
};
